import { AddressSelector } from '../molecules/AddressSelector';
import { MoneyInput } from '../atoms/MoneyInput';
import { AddModalSelectBox } from '../atoms/AddModalSelectBox';
import { DatePicker } from '../atoms/DatePicker';
import { MoneySlideUpModalInput } from '../atoms/MoneySlideUpModalInput';
import { CreditScoreInput } from '../atoms/CreditScoreInput';
import { LoanOptionBlockSmall } from '../views/comparison_views/molecules/LoanOptionBlockSmall';

export const getComponentForData = (openDataName) => {
  switch (openDataName) {
    case "street":
    case "city":
    case "county":
    case "state":
      return AddressSelector;
    case "firstTimeBuyer":
    case "propertyType":
    case "isUsCitizen":
    case "isVeteran":
    case "isSelfEmployed":
    case "hasRealEstateAgent":
    case "isBuyingAsIs":
    case "forSaleByOwner":
    case "hasTitleCompany":
    case "hasWaivedEscrow":
    case "occupancyType":
    case "takeCashOut":
    case "veteranType":
    case "disabledVeteran":
    case "vaFirstTimeUse":
    case "lookAtVaLoans":
      return AddModalSelectBox;
    case "price":
    case "downPayment":
    case "existingLoanBalance":
    case "amountOfCashOut":
      return MoneySlideUpModalInput;
    case "creditScore":
      return CreditScoreInput;
    case "plannedClosingDate":
      return DatePicker;
    case "loanOptions":
      return LoanOptionBlockSmall;
    default:
      return null;
  }
}
